import DOMPurify from "dompurify";

// Allow only inline formatting we intentionally emit from the LLM markdown pass.
const CONFIG = {
  ALLOWED_TAGS: ["strong", "em", "br", "b", "i"],
  ALLOWED_ATTR: [],
};

/**
 * Sanitise a markdown-lite string (** bold **, newlines) into safe HTML.
 * Returns an object ready for React's dangerouslySetInnerHTML.
 */
export const safeInlineHtml = (raw) => {
  const md = String(raw ?? "")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\n/g, "<br/>");
  return { __html: DOMPurify.sanitize(md, CONFIG) };
};

/**
 * Render an answer split by blank lines. Returns [{key, html}].
 * Callers should map to <p key={key} dangerouslySetInnerHTML={{__html: html}}/>.
 */
export const renderAnswerBlocks = (text) => {
  const parts = String(text ?? "").split(/\n{2,}/);
  return parts.map((p, i) => ({
    key: `p-${i}-${p.slice(0, 24)}`,
    ...safeInlineHtml(p),
  }));
};
